/* eslint-disable @typescript-eslint/no-explicit-any */
import cx from "classnames";
import React from "react";

import * as styles from "./BuildInfo.module.css";

export const BuildInfo: React.FC = () => {
  // Use the foundation's isomorphic environment helper
  // Simple environment variable access - works on both client and server
  const buildVersion =
    typeof window === "undefined" ? process.env.BUILD_VERSION : (window as any).env?.BUILD_VERSION;
  const deploymentEnv =
    typeof window === "undefined"
      ? process.env.DEPLOYMENT_ENV
      : (window as any).env?.DEPLOYMENT_ENV;

  // Only show build info in non-development environments
  if (!buildVersion || buildVersion === "0.0.0.0" || deploymentEnv === "dev") {
    return null;
  }

  // Parse build version to extract the version suffix (e.g., "2507.0202" from "PME_OnboardingBuild_1.0.2507.0202")
  const getVersionSuffix = (version: string): string => {
    // Look for pattern like "1.0.XXXX.XXXX" and extract just the "XXXX.XXXX" part
    const match = version.match(/1\.0\.(\d+\.\d+)$/);
    return match ? match[1] : version;
  };

  const displayVersion = getVersionSuffix(buildVersion);

  const colorStyle = styles.colorStyle;

  return (
    <div className={cx(styles.container, colorStyle)}>
      <div className={cx(styles.linkBig, colorStyle)}>
        <span className="build-info__label">Version: </span>
        <span className="build-info__version">{displayVersion}</span>
      </div>
    </div>
  );
};

export default BuildInfo;
